import { render } from "./RecipeListPage.vue?vue&type=template&id=fcf0605c&scoped=true"
import script from "./RecipeListPage.vue?vue&type=script&lang=js"
export * from "./RecipeListPage.vue?vue&type=script&lang=js"

import "./RecipeListPage.vue?vue&type=style&index=0&id=fcf0605c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcf0605c"]])

export default __exports__